import { computed, Service, signal } from '@angular/core';

import { Transfer } from '../models/medic-actiuni.model';
import { DocAvizare, DocCertificat, DocCertProfCurent } from '../models/medic-doc.model';
import { Medic, MedicEmc, MedicEmcTotal } from '../models/medic.model';

interface MedicState {
    medicData: Medic | null;
    medicCertDraft: DocCertificat | null;
    medicAvizDraft: DocAvizare | null;
    medicCertProfCurentDraft: DocCertProfCurent | null;
    transfer: Transfer | null;
    medicEmcTotal: MedicEmcTotal | null;
}

const initialState: MedicState = {
    medicData: null,
    medicCertDraft: null,
    medicAvizDraft: null,
    medicCertProfCurentDraft: null,
    transfer: null,
    medicEmcTotal: null,
};

/** Datele medicului deschis si ciornele documentelor lui. */
@Service()
export class MedicStore {
    private readonly state = signal<MedicState>(initialState);

    readonly medicData = computed(() => this.state().medicData);
    readonly medicCertDraft = computed(() => this.state().medicCertDraft);
    readonly medicAvizDraft = computed(() => this.state().medicAvizDraft);
    readonly medicCertProfCurentDraft = computed(() => this.state().medicCertProfCurentDraft);
    readonly transfer = computed(() => this.state().transfer);
    readonly medicEmcTotal = computed(() => this.state().medicEmcTotal);

    setMedicData(medicData: Medic | null) {
        this.patch({ medicData });
    }

    /** Inchide medicul: sterge datele si ciornele (transferul ramane, ca inainte). */
    unsetMedicData() {
        this.patch({
            medicData: null,
            medicCertDraft: null,
            medicAvizDraft: null,
            medicCertProfCurentDraft: null,
            medicEmcTotal: null,
        });
    }

    setMedicCertDraft(medicCertDraft: DocCertificat | null) {
        this.patch({ medicCertDraft });
    }

    setMedicAvizDraft(medicAvizDraft: DocAvizare | null) {
        this.patch({ medicAvizDraft });
    }

    setMedicCertProfCurentDraft(medicCertProfCurentDraft: DocCertProfCurent | null) {
        this.patch({ medicCertProfCurentDraft });
    }

    setTransfer(transfer: Transfer | null) {
        this.patch({ transfer });
    }

    setMedicEmcTotal(medicEmcTotal: MedicEmcTotal | null) {
        this.patch({ medicEmcTotal });
    }

    unsetMedicEmcTotal() {
        this.patch({ medicEmcTotal: null });
    }

    setMedicEmcList(emc: MedicEmc[]) {
        this.state.update(state => ({ ...state, medicData: state.medicData ? { ...state.medicData, emc } : state.medicData }));
    }

    private patch(changes: Partial<MedicState>) {
        this.state.update(state => ({ ...state, ...changes }));
    }
}
